export const pdfData = {
    creditNote: {
        images: ['seller/logo']
    },
    expense: {
        images: ['buyer/logo']
    },
    invoice: {
        images: ['seller/logo']
    },
    purchaseOrder: {
        images: ['buyer/logo']
    },
    quote: {
        images: ['seller/logo']
    },
    stockReceipt: {
        images: ['buyer/logo']
    },
    stockShipment: {
        images: ['seller/logo']
    }
}